var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import bookmarksConfigURL from "@adapters/infrastructures/urlConfig/Bookmarks/bookmarksURL";
import { removeEmptyKeyValuesPairs } from "@domains/utils/validation";
import { avoidAuthToken } from "@adapters/constants";
var BookmarksRepository = /** @class */ (function () {
    function BookmarksRepository(http, accountDetails) {
        this.http = http;
        this.accountDetails = accountDetails;
    }
    BookmarksRepository.prototype.getBookMarkFilters = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var reqObj, url, mutualFundsSchemes, _a, _b, _c;
            var _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        reqObj = removeEmptyKeyValuesPairs(request);
                        url = new URL(bookmarksConfigURL.filtersBookmarks);
                        _b = (_a = this.http).makeApiCall;
                        _d = {
                            method: "POST",
                            url: url.toString()
                        };
                        _c = [__assign({}, reqObj)];
                        _e = {};
                        return [4 /*yield*/, this.accountDetails.getEmployeeCode()];
                    case 1: return [4 /*yield*/, _b.apply(_a, [(_d.body = __assign.apply(void 0, _c.concat([(_e.accCode = _f.sent(), _e)])),
                                _d.avoidAuthToken = avoidAuthToken,
                                _d)])];
                    case 2:
                        mutualFundsSchemes = _f.sent();
                        return [2 /*return*/, mutualFundsSchemes];
                }
            });
        });
    };
    BookmarksRepository.prototype.saveBookmarks = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var url, req, _a, saveBookmarkResponse;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = new URL(bookmarksConfigURL.saveBookmarks);
                        _a = [__assign({}, request)];
                        _b = {};
                        return [4 /*yield*/, this.accountDetails.getEmployeeCode()];
                    case 1:
                        req = __assign.apply(void 0, _a.concat([(_b.accCode = _c.sent(), _b)]));
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "POST",
                                url: url.toString(),
                                body: req,
                            })];
                    case 2:
                        saveBookmarkResponse = _c.sent();
                        return [2 /*return*/, saveBookmarkResponse];
                }
            });
        });
    };
    BookmarksRepository.prototype.fetchBookmarks = function (req) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var url, reqObj, bookmarksResponse, allBookmarksResponse, _d, _e, _f;
            var _g, _h;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        url = new URL(bookmarksConfigURL.fetchBookmarks);
                        reqObj = removeEmptyKeyValuesPairs(req);
                        bookmarksResponse = {
                            mutualFundSummary: [],
                            totalPages: 0,
                            totalRecord: 0,
                        };
                        _e = (_d = this.http).makeApiCall;
                        _g = {
                            method: "POST",
                            url: url.toString()
                        };
                        _f = [__assign({}, reqObj)];
                        _h = {};
                        return [4 /*yield*/, this.accountDetails.getEmployeeCode()];
                    case 1: return [4 /*yield*/, _e.apply(_d, [(_g.body = __assign.apply(void 0, _f.concat([(_h.accCode = _j.sent(), _h)])),
                                _g)])];
                    case 2:
                        allBookmarksResponse = _j.sent();
                        bookmarksResponse.mutualFundSummary =
                            ((_a = allBookmarksResponse === null || allBookmarksResponse === void 0 ? void 0 : allBookmarksResponse.data) === null || _a === void 0 ? void 0 : _a.mutualFundSummary) || [];
                        bookmarksResponse.totalPages =
                            Math.ceil(((_b = allBookmarksResponse === null || allBookmarksResponse === void 0 ? void 0 : allBookmarksResponse.data) === null || _b === void 0 ? void 0 : _b.totalRecords) / Number(req.pageSize)) || 0;
                        bookmarksResponse.totalRecord =
                            ((_c = allBookmarksResponse === null || allBookmarksResponse === void 0 ? void 0 : allBookmarksResponse.data) === null || _c === void 0 ? void 0 : _c.totalRecords) || 0;
                        return [2 /*return*/, bookmarksResponse];
                }
            });
        });
    };
    BookmarksRepository.prototype.deleteBookmarks = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var url, req, _a, deleteBookmarkResponse;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = new URL(bookmarksConfigURL.deleteBookmarks);
                        _a = [__assign({}, request)];
                        _b = {};
                        return [4 /*yield*/, this.accountDetails.getEmployeeCode()];
                    case 1:
                        req = __assign.apply(void 0, _a.concat([(_b.accCode = _c.sent(), _b)]));
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "DELETE",
                                url: url.toString(),
                                body: req,
                            })];
                    case 2:
                        deleteBookmarkResponse = _c.sent();
                        return [2 /*return*/, deleteBookmarkResponse];
                }
            });
        });
    };
    return BookmarksRepository;
}());
export default BookmarksRepository;
